import Store from "App/Store.js";

export default cookieConsentToOptional => Store.dispatch({type: "cookieConsentToOptional", cookieConsentToOptional});
